/**
 * AVATAR-MONOGRAM a névből: az első + az utolsó szó kezdőBETŰJE (egy szónál az első kettő).
 *
 * ⚠️ CSAK BETŰ/SZÁMJEGY kerülhet bele. A nyers „első karakter" írásjelet is beengedett: a gépi
 * `notify-service (atlas)` avatarja **„N("** lett (mérve az eseménynaplón), mert a második szó a nyitó
 * zárójellel kezdődik — és ugyanez ütne minden zárójeles vagy idézőjeles néven. A szűrés `\p{L}\p{N}`
 * unicode-osztályon megy, tehát az ékezet megmarad (Árpád → Á).
 *
 * Betű nélküli szó (pl. „(…)", „—") KIMARAD a választásból; ha egyetlen betű sincs, a jel `?`.
 *
 * KÜLÖN FÁJLBAN (nem az `avatar.tsx`-ben): tiszta segédfüggvény, és a komponens-fájlból exportálva a
 * react-refresh elveszti a gyors-frissítést (a repo lint-szabálya ezt ki is mondja).
 */
export function initials(name: string): string {
  const letters = /[\p{L}\p{N}]/u;
  const heads = name
    .trim()
    .split(/\s+/)
    .map((w) => [...w].find((ch) => letters.test(ch)))
    .filter((ch): ch is string => ch !== undefined);
  if (heads.length === 0) return '?';
  if (heads.length === 1) {
    // EGY szó: az első KÉT betűje (szintén írásjel nélkül) — pl. „e2e-admin" → „E2".
    const only = [...name.trim()].filter((ch) => letters.test(ch)).slice(0, 2);
    return only.join('').toUpperCase() || '?';
  }
  return (heads[0]! + heads[heads.length - 1]!).toUpperCase();
}
